import { render, staticRenderFns } from "./ServiceProcessPrice.vue?vue&type=template&id=80950ff8&scoped=true"
import script from "./ServiceProcessPrice.vue?vue&type=script&lang=js"
export * from "./ServiceProcessPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80950ff8",
  null
  
)

export default component.exports